export default {"src":"/_next/static/image/public/images/ic_minus_filter.d876bde705c3a560494fd5fac0713d0c.svg","height":16,"width":16};